export default __webpack_public_path__ + "media/images/casatb/tenant/how-to-rent-three-5427794f20ed9eb0601cc9e2a5277af6.png";